module.exports = __webpack_public_path__ + "static/media/mountain_biking_1600.fb645fa5.jpg";